import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center" data-testid="not-found-page">
      <p className="label-small text-[#C5A059] mb-3">404</p>
      <h1 className="font-display text-5xl text-[#2C2A29]">Page not found</h1>
      <p className="text-[#8A8480] mt-4">The page you're looking for has wandered off.</p>
      <Link to="/"><Button className="btn-primary mt-8 rounded-full px-6 py-5 h-auto">Back home</Button></Link>
    </div>
  );
}
